import { useEffect, useState } from 'react';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { GoogleIntegration } from '../../../commonTypes/user.types';

const useHttpGetGoogleIntegrationOnMount = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);

    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<GoogleIntegration>();

    useEffect(() => {
        const { exec, abort } = userApi.getGoogleIntegration({
            onSuccess: res => setData(res.body),
            onFinally: () => setIsReady(true),
            onError: error => {
                if (!error.includes('is not found by search condition:')) toastHandler.push('error', `An unexpected error has ocurred.`);
            },
        });
        exec();
        return abort;
    }, []);
    return { isReady, data };
};

export default useHttpGetGoogleIntegrationOnMount;
